import ethanPic from "@/public/images/artists/ethan.png";
import { Artist } from "@/types/types";

export const ethan = {
  id: "12",
  name: "Ethan",
  image: ethanPic,
  description: `Ethan is your go to male pop singer. He possesses an astonishing vocal range that effortlessly spans from velvety lows to soaring highs.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fethan-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Pop", "Dance", "Falsetto"],
      secondary: ["Singer"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 48,
        high: 70,
      },
    },
  },
} as const satisfies Artist;
